import React, { useEffect } from "react";

// Keep in sync with VOUCHER_FORM_URL in ../homepage/homepage.component.jsx
const VOUCHER_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScexH3YwEfCpiGgrlhIKvFjsDdmT-9fyg5wzJGl9GRVqmYx9g/viewform?usp=sharing&ouid=105292569075889813610";

const VoucherRedirect = () => {
  useEffect(() => {
    window.location.replace(VOUCHER_FORM_URL);
  }, []);

  return (
    <p style={{ textAlign: "center", padding: "40px 20px" }}>
      Taking you to the voucher form... if nothing happens,{" "}
      <a href={VOUCHER_FORM_URL}>click here</a>.
    </p>
  );
};

export default VoucherRedirect;
